module.exports = __webpack_public_path__ + "static/media/  (110).73d38c8b.jpg";